module.exports = __webpack_public_path__ + "img/monitor-active.149f3140.svg";